// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__jnfSP","loadingIcon":"Button_loadingIcon__mGKy5","loading":"Button_loading__NXH5D","slim":"Button_slim__z0Gng","disabled":"Button_disabled__aqrA7"};